// extracted by mini-css-extract-plugin
module.exports = {"gallerySideBySide":"SideBySideGallery_gallerySideBySide__eNydi","imgWrapper":"SideBySideGallery_imgWrapper__hvRWE"};